import { useEffect } from 'react';
import logo from '/isologo.svg';
import { ConnectButton } from '@rainbow-me/rainbowkit';
import { useAccount } from 'wagmi';
import { Link, useNavigate, useLocation } from 'react-router-dom';

export default function Header() {
  const { isConnected } = useAccount();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Redirect to /app when wallet connects, but only from landing page
    // We check if the pathname is one of the landing page routes
    const isLandingPage = location.pathname === '/' ||
      ['/how-it-works', '/features', '/architecture', '/roadmap'].includes(location.pathname);

    if (isConnected && isLandingPage) {
      navigate('/app');
    }
    // Redirect to landing page when wallet disconnects from /app
    if (!isConnected && location.pathname === '/app') {
      navigate('/');
    }
  }, [isConnected, navigate, location.pathname]);

  return (
    <header className="header">
      <div className="container">
        <nav className="nav">
          <Link to="/">
            <img className="logo" src={logo} />
          </Link>
          <ul className="nav-menu">
            <li><Link to="/how-it-works">How it Works</Link></li>
            <li><Link to="/features">Features</Link></li>
            <li><Link to="/architecture">Architecture</Link></li>
            <li><Link to="/roadmap">Roadmap</Link></li>
          </ul>

          <div className="nav-actions">
            <ConnectButton />
          </div>
        </nav>
      </div>
    </header>
  );
}
